export default __webpack_public_path__ + "static/media/math-round-image.b72db2bb.png";